var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-verification',{attrs:{"banner":false,"signupPopUp":_vm.signupPopUp,"emailVerification":_vm.emailVerification,"guestUser":_vm.guestUser,"showGuestLogin":_vm.showGuestLogin,"path":_vm.path}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }